module.exports = __webpack_public_path__ + "static/media/cognition941d89c9.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/icons/categories/cognition.svg
// module id = 1320
// module chunks = 0